"use client";

import { useEffect, useRef, useState } from "react";
import useStore from "../../../lib/Store/useStore";
import OpenCart from "../NewHeaderSection/OpenCart";
import { getCartRest } from "../../../lib/bigcommerce/restfull/apis/cartAPIS";
import { motion } from "framer-motion";
import Link from "next/link";
import NewPrimaryButton from "../../Atoms/Buttons/NewPrimaryButton";
import { useRouter } from "next/navigation";
import { FRONTEND_ENDPOINTS } from "../../../public/Constants/endpoints";

const CartDropDown = () => {
    const router = useRouter();
    const cartRef = useRef(null);
    const quantityRef = useRef(null);
    const { cartData, cartId, updateCartData, currency } = useStore();
    const [openCart, setOpenCart] = useState(false);
    const [latestItem, setLatestItem] = useState(null);
    const closeTimeoutRef = useRef(null);

    useEffect(() => {
        const getcart = async () => {
            const responce = await getCartRest(cartId, currency);
            quantityRef.current = responce?.totalQuantity;
            updateCartData(responce);
        };
        if (cartId && !cartData) getcart();
    }, [cartId]);

    useEffect(() => {
        if (cartData?.line_items?.physical_items?.length > 0) {
            setLatestItem(
                cartData?.line_items?.physical_items[
                    cartData?.line_items?.physical_items?.length - 1
                ]
            );
        }
    }, [openCart]);

    useEffect(() => {
        // Open cart modal when quantity changes.
        if (
            cartData?.totalQuantity !== quantityRef?.current &&
            cartData?.totalQuantity > 0
        ) {
            // But only if it's not already open (quantity also changes when editing items in cart).
            if (!openCart) {
                setOpenCart(true);
            }
            // Always update the quantity reference
            quantityRef.current = cartData?.totalQuantity;
        }
    }, [openCart, cartData?.totalQuantity, quantityRef]);

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (cartRef.current && !cartRef.current.contains(event.target)) {
                setOpenCart(false);
            }
        };

        if (openCart) {
            document.addEventListener("mousedown", handleClickOutside);
        }

        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [openCart]);

    useEffect(() => {
        if (openCart) {
            // Clear any existing timeout
            if (closeTimeoutRef.current) {
                clearTimeout(closeTimeoutRef.current);
            }
            // Set a new timeout to close the cart after 5 minutes (300000ms)
            closeTimeoutRef.current = setTimeout(() => {
                setOpenCart(false);
            }, 3000);
        }

        return () => {
            // Cleanup timeout when the component unmounts or cart closes
            if (closeTimeoutRef.current) {
                clearTimeout(closeTimeoutRef.current);
            }
        };
    }, [openCart]);

    return (
        <div className="relative inline-block" ref={cartRef}>
            <Link href={FRONTEND_ENDPOINTS?.CART}>
                <OpenCart quantity={cartData?.totalQuantity || 0} />
            </Link>
            <motion.div
                initial={{ opacity: 0, y: -10 }}
                animate={{ opacity: openCart ? 1 : 0, y: openCart ? 0 : -10 }}
                transition={{ duration: 0.3 }}
                className="absolute right-0 mt-2 w-[343px] h-[226px] bg-white shadow-lg rounded-md overflow-hidden z-30 justify-center items-center flex-col"
                style={{ display: openCart ? "flex" : "none", top: "100%" }}
            >
                {latestItem && (
                    <div className="p-4 flex items-center">
                        <img
                            src={
                                latestItem?.product?.primary_image?.url_standard
                            }
                            alt={latestItem?.name}
                            className="w-[100px] h-[120px] object-cover mr-4"
                        />
                        <p className="flex-1">
                            {latestItem?.name} has been added to your cart.
                        </p>
                    </div>
                )}
                <NewPrimaryButton
                    text={"Go TO SHOPPING CART"}
                    href={FRONTEND_ENDPOINTS?.CART}
                />
            </motion.div>
        </div>
    );
};
export default CartDropDown;
